import { Billing } from '..'

export const UrlSearchParamKey = {
    couponApplied: 'couponApplied',
    err: 'err',
} as const

export const UrlSearchParam = {
    [UrlSearchParamKey.couponApplied]: Billing.Coupon.ReportUpgrades20Percent3Months,
    [UrlSearchParamKey.err]: 'couponNotApplied',
} as const

export const Error = {
    MissingQueryParam: 'MISSING_QUERY_PARAM: groupUuid',
    InvalidGroupUuid: 'INVALID_GROUP_UUID: not a string',
    CouldNotDetermineUserId: 'COULD_NOT_DETERMINE_USER_ID',
    InvalidGroup: 'GROUP_IS_NOT_TRIALING_OR_NOT_IN_PLAN_V4_S_MONTHLY',
} as const
